/** Client-side IBAN validation (format + MOD-97). Mirrors the server check. */
export function normalizeIban(iban: string): string {
  return iban.replace(/\s+/g, '').toUpperCase()
}

export function isValidIban(iban: string): boolean {
  const s = normalizeIban(iban)
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(s)) return false
  const rearranged = s.slice(4) + s.slice(0, 4)
  let remainder = 0
  for (const ch of rearranged) {
    const code = ch.charCodeAt(0)
    const value = code >= 65 ? code - 55 : code - 48
    remainder = value > 9 ? (remainder * 100 + value) % 97 : (remainder * 10 + value) % 97
  }
  return remainder === 1
}
